// Which page `/` is, signed out (02-DESIGN/03-console/03-the-signed-out-site.md
// § the address; decisions 0054 and 0074): where the platform profile lets a
// stranger sign up, or names an address to ask for a workspace at
// (`request_access`), the signed-out site with the sign-in card inside it;
// where it does neither — an install that admits only its own people and
// says nothing to a stranger — the sign-in card alone. The install decides by
// facts it already publishes; the bundle carries none.

import type { PlatformProfile } from "../../platform/profile.ts";

/** Front is what `/` shows a person who is not signed in. */
export type Front = "site" | "sign-in";

/** frontOf reads it off the platform profile's `sign_up` and `request_access`. */
export function frontOf(platform: Pick<PlatformProfile, "sign_up" | "request_access">): Front {
  return platform.sign_up || requestAccessOf(platform) !== undefined ? "site" : "sign-in";
}

/**
 * requestAccessOf is the address the front page's *Request access* opens:
 * the profile's `request_access` where sign-up is off and the value is a
 * `mailto:` or `https:` address, else nothing. A profile that allows sign-up
 * admits; it does not ask.
 */
export function requestAccessOf(
  platform: Pick<PlatformProfile, "sign_up" | "request_access">,
): string | undefined {
  if (platform.sign_up) {
    return undefined;
  }
  const v = platform.request_access;
  if (typeof v !== "string" || v === "") {
    return undefined;
  }
  let scheme: string;
  try {
    scheme = new URL(v).protocol;
  } catch {
    return undefined;
  }
  return scheme === "mailto:" || scheme === "https:" ? v : undefined;
}
